var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from 'react';
import Icon from '../../../icon';
import Typography from '../../../typography';
import { NavigationContext } from '../../provider';
import { NavigationActionToggle } from '../NavigationActionToggle';
import { NavigationActionToggleSearchButtonContainer, NavigationActionToggleSearchContainer, } from './styles/navigation-action-toggle-search.styled';
export const NavigationActionToggleSearch = (_a) => {
    var { children, reference, standalone, onClick, dataTest = 'navigation-action-toggle' } = _a, props = __rest(_a, ["children", "reference", "standalone", "onClick", "dataTest"]);
    const { activeItemReference, activeActionReference, setActiveActionReference, navigationIsOpen, navigationViewportBreakpoint, } = useContext(NavigationContext);
    const isToggleSearchIconButton = ['xxs', 'xs', 'sm', 'lg', 'xl'].includes(navigationViewportBreakpoint) && !standalone;
    const isMobileAndShowingSubItems = ['xxs', 'xs', 'sm', 'md'].includes(navigationViewportBreakpoint) && activeItemReference;
    if (isToggleSearchIconButton) {
        return _jsx(NavigationActionToggle, { reference: reference, icon: "search", dataTest: dataTest });
    }
    if (isMobileAndShowingSubItems) {
        return null;
    }
    return (_jsx(NavigationActionToggleSearchContainer, { "$standalone": standalone, "data-test": dataTest, children: _jsxs(NavigationActionToggleSearchButtonContainer, Object.assign({ "$navigationIsOpen": navigationIsOpen, "$loginMenuIsOpen": activeActionReference === 'login', "$standalone": standalone, onClick: (e) => {
                setActiveActionReference(activeActionReference === reference ? null : reference);
                if (onClick) {
                    onClick(e);
                }
            } }, props, { children: [_jsx(Icon, { variant: "search", size: "lg" }), _jsx(Typography, { variant: "body-text-xs", tagName: "span", children: children })] })) }));
};
